/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create an appointment from the portal patient
 * @export
 * @interface PortalAppointmentRequest
 */
export interface PortalAppointmentRequest {
    /**
     * the unique identifier of the portal patient
     * @type {string}
     * @memberof PortalAppointmentRequest
     */
    patientUuid?: string;
    /**
     * the unique identifier of the doctor for the appointment
     * @type {string}
     * @memberof PortalAppointmentRequest
     */
    doctorUuid?: string;
    /**
     * the unique identifier of the institute from where the doctor will take the appointment
     * @type {string}
     * @memberof PortalAppointmentRequest
     */
    instituteUuid?: string;
    /**
     * the unique identifier of the appointment type
     * @type {string}
     * @memberof PortalAppointmentRequest
     */
    appointmentType?: string;
    /**
     * The appointment date time to reserve
     * @type {string}
     * @memberof PortalAppointmentRequest
     */
    appointmentDateTime?: string;
    /**
     * A comment from the user to the doctor
     * @type {string}
     * @memberof PortalAppointmentRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the PortalAppointmentRequest interface.
 */
export function instanceOfPortalAppointmentRequest(value: object): value is PortalAppointmentRequest {
    return true;
}

export function PortalAppointmentRequestFromJSON(json: any): PortalAppointmentRequest {
    return PortalAppointmentRequestFromJSONTyped(json, false);
}

export function PortalAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'patientUuid': json['patientUuid'] == null ? undefined : json['patientUuid'],
        'doctorUuid': json['doctorUuid'] == null ? undefined : json['doctorUuid'],
        'instituteUuid': json['instituteUuid'] == null ? undefined : json['instituteUuid'],
        'appointmentType': json['appointmentType'] == null ? undefined : json['appointmentType'],
        'appointmentDateTime': json['appointmentDateTime'] == null ? undefined : json['appointmentDateTime'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function PortalAppointmentRequestToJSON(json: any): PortalAppointmentRequest {
    return PortalAppointmentRequestToJSONTyped(json, false);
}

export function PortalAppointmentRequestToJSONTyped(value?: PortalAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientUuid': value['patientUuid'],
        'doctorUuid': value['doctorUuid'],
        'instituteUuid': value['instituteUuid'],
        'appointmentType': value['appointmentType'],
        'appointmentDateTime': value['appointmentDateTime'],
        'comment': value['comment'],
    };
}

